import { Tipo_mod } from './../../../models/tipo_mod.model';
import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
    selector: "page-tipo_mod",
    templateUrl: "./tipo_mod.component.html"
    
})


export class Tipo_modComponent {
    public rows = [];
    public actualRow;
    public tipo_mod: Tipo_mod;
    public form;
    public number;
    
    constructor(){

        this.number = localStorage.getItem("form");
        
        this.form = new FormGroup({
            mod1: new FormControl('', Validators.required),
            mod2:new FormControl('', Validators.required),
            mod3:new FormControl('', Validators.required),
            mod4:new FormControl('', Validators.required),
            
        })
        if(!JSON.parse(localStorage.getItem("tipo_mod"))){
            localStorage.setItem("tipo_mod", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_mod"));
            this.form.controls['mod1'].setValue(this.rows[0]?this.rows[0].loteo:'NO')
            this.form.controls['mod2'].setValue(this.rows[0]?this.rows[0].urbanizacion:'NO')
            this.form.controls['mod3'].setValue(this.rows[0]?this.rows[0].loteo_construccion:'NO')
            this.form.controls['mod4'].setValue(this.rows[0]?this.rows[0].loteo_dfl2:'NO')
        }
        this.tipo_mod= {loteo:'',urbanizacion:'',loteo_construccion:'', loteo_dfl2:''}
    }

    add_tipo_mod(){
        



        localStorage.setItem("tipo_mod",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_mod");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            'loteo': this.form.value.mod1, 
            'urbanizacion': this.form.value.mod2,
            'loteo_construccion': this.form.value.mod3,
            'loteo_dfl2': this.form.value.mod4
        })
        localStorage.setItem("tipo_mod", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_mod")));
    }
  
    delete_tipo_mod(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_mod", JSON.stringify(this.rows));
            }
        }
    }   
}